import { Component, Input } from '@angular/core';
import * as Global from '../../../../../global';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HelpersService } from '../../../../../services/helpers.service';
import { MatIconModule } from '@angular/material/icon';
import { ToastService } from '@app/services/toast.service';
import moment from 'moment';
import { NavService } from '../../../../../services/nav.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { TitleCasePipe } from '@angular/common';
import { ExpenseService } from '../../../../../services/expense.service';

@Component({
  selector: 'new-travel-doc',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, NgSelectModule, TitleCasePipe],
  templateUrl: './new-travel-doc.component.html',
  styleUrl: './new-travel-doc.component.scss'
})
export class NewTravelDocComponent {
  Global = Global
  @Input() data: any;
  formGroup!: FormGroup;
  constructor(
    private expenseService: ExpenseService,private helpers: HelpersService,
    private fb: FormBuilder,
    public toastr: ToastService,
    public navService: NavService
  ) {

  }
  ngOnInit() {
    this.formInitialise()
    this.initData()
  }
  formInitialise() {
    this.formGroup = this.fb.group({
      userId: [
        this.helpers.userId(),
        Validators.compose([Validators.required]),
      ],
      fileName: [null, Validators.compose([Validators.required])],
      documentData: [null, Validators.compose([Validators.required])],
      fileNameBack: [null, Validators.compose([])],
      documentDataBack: [null, Validators.compose([])],
      othersName: [null, Validators.compose([])],
      id: [null, Validators.compose([])],
      docType: [null, Validators.compose([Validators.required])],
      docNumber: [null, Validators.compose([Validators.required])],
      issuedOn: [null, Validators.compose([Validators.required])],
      validTill: [null, Validators.compose([Validators.required])],
      isVerified: [true, Validators.compose([Validators.required])],
    });
  }
  ngOnChanges() {
    this.initData()
  }
  initData() {
    if (this.data?.action == 'update') {
      this.formInitialise()
      this.formGroup.patchValue({
        id: this.data?.id ?? null,
        docNumber: this.data?.docNumber ?? null,
        fileName: this.data?.fileName ?? null,
        fileNameBack: this.data?.fileNameBack ?? null,
        issuedOn: this.data?.issuedOn
          ? moment(this.data?.issuedOn).format('YYYY-MM-DD')
          : null,
        validTill: this.data?.issuedOn
          ? moment(this.data?.validTill).format('YYYY-MM-DD')
          : null,
      });
      if (
        this.data?.docType &&
        (this.data?.docType == 'PAN' ||
          this.data?.docType == 'AADHAAR' ||
          this.data?.docType == 'EPIC')
      ) {
        this.formGroup.patchValue({
          docType: this.data?.docType ?? null,
          othersName: null,
        });
      } else {
        this.formGroup.patchValue({
          docType: 'OTHERS',
          othersName: this.data?.docType,
        });
      }
      if (this.data?.id) {
        this.formGroup.get('documentData')?.clearValidators();
        this.formGroup.get('documentData')?.updateValueAndValidity();
        this.formGroup.get('fileName')?.clearValidators();
        this.formGroup.get('fileName')?.updateValueAndValidity();
        this.formGroup.get('fileNameBack')?.clearValidators();
        this.formGroup.get('fileNameBack')?.updateValueAndValidity();
        this.formGroup.get('documentDataBack')?.clearValidators();
        this.formGroup.get('documentDataBack')?.updateValueAndValidity();
      }

    }
    else {
      this.formGroup.patchValue({
        id: null,
        docNumber: null,
        fileName: null,
        fileNameBack: null,
        docType: null,
        issuedOn: null,
        validTill: null,
      });
      this.formGroup.get('documentData')?.setValidators([Validators.required]);
      this.formGroup.get('documentData')?.updateValueAndValidity();
      this.formGroup.get('fileName')?.setValidators([Validators.required]);
      this.formGroup.get('fileName')?.updateValueAndValidity();
    }
  }
  clear(isBack: boolean = false) {
    if (isBack) {
      this.formGroup.patchValue({
        fileNameBack: null,
        documentDataBack: null,
      });
    } else {
      this.formGroup.patchValue({
        fileName: null,
        documentData: null,
      });
    }
  }
  saveDoc() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      let formData = this.formGroup.value;
      formData.issuedOn = formData.issuedOn
        ? this.helpers.formatDateToISO(formData.issuedOn)
        : null;
      formData.validTill = formData.validTill
        ? this.helpers.formatDateToISO(formData.validTill)
        : null;
      formData.docType = this.formGroup.value.othersName
        ? this.formGroup.value.othersName
        : this.formGroup.value.docType;
      if (!formData.documentData) {
        delete formData.documentData;
        delete formData.fileName;
      }
      if (!formData.documentDataBack) {
        delete formData.documentDataBack;
        delete formData.fileNameBack;
      }
      this.expenseService.submitTravelDocument(formData, formData.id ? false : true)
        .subscribe({
          next: (res) => {
            this.toastr.success(`Travel Document saved successfully`);
            this.resetForm();
            this.navService.triggerRefresh('travel-documents');
          },
          error: (err) => {
          },
          complete: () => {
          },
        });
    }
  }
  resetForm() {
    this.formGroup.reset();
    // this.toggleAddNew = !this.toggleAddNew;
    this.onDocTypeChange()
    // this.formGroup.patchValue({
    //   userId: this.helpers.userId(),
    //   docType: '',
    //   isVerified: true,
    // });
    this.closeNav()
  }
  onDocTypeChange() {
    const docType = this.formGroup.value?.docType;
    let othersNameControl = this.formGroup.get('othersName');

    if (othersNameControl) {
      if (othersNameControl.value) {
        if (docType !== 'PAN' && docType !== 'AADHAAR' && docType !== 'EPIC') {
          othersNameControl.setValidators([Validators.required]);
        } else {
          othersNameControl.patchValue(null);
          othersNameControl.clearValidators();
        }
      } else {
        // Optionally handle the case where othersName is empty
        othersNameControl.clearValidators(); // or any other logic you want to apply
      }

      othersNameControl.updateValueAndValidity();
    }
  }
  closeNav() {
    this.navService.openSideNav({
      toogle: true,
    })
  }

}
